module.exports = __webpack_public_path__ + "static/media/reward-fr.688326bc.webp";